// src/components/Wrapper.js
import React from 'react';
import styled from 'styled-components';
import { ChatProvider, useChat } from '../context/ChatProvider'; // Import the useChat hook
import Login from './Login';
import ChatContainer from './ChatContainer';

// WrapperContainer is the container for centering everything on the screen
const WrapperContainer = styled.div`
    display: grid;
    height: 100vh;
    place-items: center; /* Center content both vertically and horizontally */
`;

// InnerWrapper is the component that uses the useChat hook
const InnerWrapper = () => {
    const { username } = useChat(); // Access username from context

    return (
        <WrapperContainer>
            {!username ? <Login /> : <ChatContainer />}
        </WrapperContainer>
    );
};

const Wrapper = () => {
    return (
        <ChatProvider>
            <InnerWrapper />
        </ChatProvider>
    );
};

export default Wrapper;
